import React from 'react';
import { Star } from 'lucide-react';
export function InitialReviews() {
  return <section className="py-12 bg-[#FBF6EC]" data-id="element-224">
      <div className="max-w-5xl mx-auto px-4" data-id="element-225">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-226">
          <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm" data-id="element-227">
            <div className="flex text-amber-400 mb-3" data-id="element-228">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-229" />)}
            </div>
            <p className="text-stone-700 italic mb-4" data-id="element-230">
              "Organicé todo el año de Lengua en una tarde. No lo puedo creer."
            </p>
            <div className="text-sm font-bold text-stone-900" data-id="element-231">
              MG — MARIELA G.
            </div>
            <div className="text-xs text-stone-500 uppercase tracking-wide" data-id="element-232">
              CÓRDOBA | PRIMARIA
            </div>
          </div>

          <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm" data-id="element-233">
            <div className="flex text-amber-400 mb-3" data-id="element-234">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-235" />)}
            </div>
            <p className="text-stone-700 italic mb-4" data-id="element-236">
              "Mis alumnos de secundaria por fin leen sin quejarse. El material
              engancha."
            </p>
            <div className="text-sm font-bold text-stone-900" data-id="element-237">
              LP — LAURA P.
            </div>
            <div className="text-xs text-stone-500 uppercase tracking-wide" data-id="element-238">
              ROSARIO | SECUNDARIA
            </div>
          </div>

          <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm" data-id="element-239">
            <div className="flex text-amber-400 mb-3" data-id="element-240">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-241" />)}
            </div>
            <p className="text-stone-700 italic mb-4" data-id="element-242">
              "Nunca más llegué a clase sin saber qué dar. Esto cambió todo."
            </p>
            <div className="text-sm font-bold text-stone-900" data-id="element-243">
              RM — ROBERTO M.
            </div>
            <div className="text-xs text-stone-500 uppercase tracking-wide" data-id="element-244">
              BUENOS AIRES | PRIM. Y SEC.
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function FullReviews() {
  const reviews = [{
    initials: 'MG',
    name: 'Mariela G.',
    loc: '📍 Córdoba | Docente de Lengua Primaria',
    text: 'Compré el Pack un domingo a la noche. El lunes tenía todo organizado por grado. Las actividades están pensadas para que los chicos realmente aprendan, no solo para llenar el tiempo de clase.'
  }, {
    initials: 'CR',
    name: 'Cecilia R.',
    loc: '📍 Mendoza | Docente Primaria y Secundaria',
    text: 'Empecé con Primaria y a los 3 días compré el Pack Completo. Doy clases en los dos niveles y no podía trabajar con la mitad. Los bonus de gestión me cambiaron la vida.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    loc: '📍 Buenos Aires | Docente de Lengua',
    text: 'Lo que más valoro es que está organizado POR GRADO Y AÑO. No tengo que adivinar qué le corresponde a cada curso. Todo ya está pensado y secuenciado.'
  }, {
    initials: 'FL',
    name: 'Florencia L.',
    loc: '📍 Tucumán | Docente de Lengua Primaria',
    text: 'Tenía miedo de que fuera material genérico. Pero desde la primera clase noté que está pensado para Argentina, para el aula real, para docentes que tienen 30 chicos y poco tiempo.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    loc: '📍 Rosario | Docente de Lengua Secundaria',
    text: 'Mis alumnos de 3ro y 4to año por fin leen sin protestar. Los textos son actuales, no de los libros de los 90. Se acabó la pregunta: ¿para qué leemos esto?'
  }, {
    initials: 'VT',
    name: 'Valeria T.',
    loc: '📍 Santa Fe | Docente de Lengua Primaria',
    text: 'Entregué la Planificación Anual el primer día. Mi directora me preguntó cómo la tenía tan completa. Ni le conté que tardé 5 minutos en personalizar el documento.'
  }];
  return <section className="py-16 bg-stone-50" data-id="element-245">
      <div className="max-w-6xl mx-auto px-4" data-id="element-246">
        <div className="text-center mb-12" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-248">
            Lo que dicen los docentes de Lengua que ya tienen su Pack:
          </h2>
          <p className="text-xl text-rose-800 font-medium" data-id="element-249">
            +1.500 docentes de Argentina ya lo usan
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-250">
          {reviews.map((r, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-md border border-stone-200 flex flex-col h-full" data-id="element-251">
              <div className="flex items-center gap-4 mb-4" data-id="element-252">
                <div className="w-12 h-12 bg-rose-100 text-rose-800 rounded-full flex items-center justify-center font-bold text-xl" data-id="element-253">
                  {r.initials}
                </div>
                <div data-id="element-254">
                  <div className="flex text-amber-400 mb-1" data-id="element-255">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-256" />)}
                  </div>
                  <div className="font-bold text-stone-900" data-id="element-257">{r.name}</div>
                </div>
              </div>
              <p className="text-stone-600 italic flex-grow" data-id="element-258">"{r.text}"</p>
              <div className="mt-6 pt-4 border-t border-stone-100 text-sm text-stone-500 font-medium" data-id="element-259">
                {r.loc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}